module.exports = __webpack_public_path__ + "img/8.bf164e11.png";